import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { userApi } from '../userApi';
import {
  type GetUsersRequest,
  type GetUsersWithPaginationResponse,
} from '../types';

export const useGetUsersWithPagination = (params: GetUsersRequest) => {
  return useQuery({
    queryKey: [QueryKey.GET_USERS_WITH_PAGINATION, params],
    queryFn: () => userApi.getUsers<GetUsersWithPaginationResponse>(params),
    retry: false,
  });
};
